import React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import SplashScreen from 'common/modules/ui/components/SplashScreen';

const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

function PrintingPage({ children, loading, t }) {
  return (
    <PageWrapper>
      <Helmet>
        <title>{t('slogan')}</title>
      </Helmet>
      {loading && <SplashScreen />}
      {!loading &&
        <React.Fragment>
          {children}
        </React.Fragment>
      }
    </PageWrapper>
  );
}

export default translate()(PrintingPage);



// WEBPACK FOOTER //
// ./src/common/components/PrintingPage.js